module.exports = __webpack_public_path__ + "static/netWorthMobileBox-7cfaf2c1cf51a7c778900eae6e99fbb7.png";